'use es6';

import PropTypes from 'prop-types';
import { BaseResponsiveToolbar, buildActionsForModuleOutsideContainer } from './BaseResponsiveToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileModuleToolbarOutsideContainerToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleOutsideContainer({
      isInNonDefaultBreakpointMode
    }),
    responsiveSize: responsiveSize
  });
};
MockResponsiveMobileModuleToolbarOutsideContainerToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired
};
const MockResponsiveDesktopModuleToolbarOutsideContainerToMeasure = ({
  responsiveSize
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleOutsideContainer({}),
    responsiveSize: responsiveSize
  });
};
MockResponsiveDesktopModuleToolbarOutsideContainerToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired
};
export { MockResponsiveDesktopModuleToolbarOutsideContainerToMeasure, MockResponsiveMobileModuleToolbarOutsideContainerToMeasure };